<template>
  <div id="welcome">
    <div style="background: #fff; overflow: hidden">
      <SearchQuery :creatBy='creatBy' ref="search" class="search-content">
        <el-button type="primary" icon="el-icon-search" size="small" style="margin-left: 15px" @click="search">{{
          $t("message.button.search") }}
        </el-button>
        <!-- <el-checkbox style="margin-left: 15px;bottom: -8px;" v-model="checked">仅搜索一层BOM</el-checkbox> -->
      </SearchQuery>
      <div style="height: 6px;"></div>
    </div>
    <div class="search_cotent">
      <div v-loading="loading">

        <vxe-table border ref="xTable" show-overflow resizable :row-config="{ isHover: true }" height="440"
          class="mytable-scrollbar" :data="tableData">
          <vxe-column type="checkbox" width="60"></vxe-column>

          <vxe-column v-for="item in columnList" :key="item.index" :field="item.field" :title="item.title"
            :minWidth="item.miniWidth" sortable>
          </vxe-column>
        </vxe-table>

      </div>

    </div>
  </div>
</template>
<script>
import 'font-awesome/css/font-awesome.min.css'
import NProgress from "nprogress"; // 引入nprogress插件
import "nprogress/nprogress.css";
import TitleTag from "@/components/titleTag";
import SearchQuery from "@/views/workBench/search/searchItem/search.vue";
import axios from "axios";
// import XEUtils from "xe-utils";
import XLSX from "xlsx";
import FileSaver from "file-saver";
export default {
  name: "Show",
  data() {
    return {
      checked: false,
      loading: false,
      reportPage: true,

      pageSizes: [100, 200, 500, 1000],
      pageSize: 100,
      currentPage: 1,
      creatBy: 'project',

      totalRols: "",
      search_data: "",
      get_data: [],
      selectGroup: [],
      select_value: "",
      checkedList: [],
      uncheckedList: [],


      tableToolbar: {
        print: true,
        // export:true,
        zoom: true,

        // custom: true,
        buttons: [{ code: 'myInsert', name: '', type: 'text', },],
        slots: {
          tools: "tools",
        },
      },
      tableData: [],
      columnList: [],
      gridOptions: {
        columns: [],
        data: [],
        border: true,
        resizable: true,
        showOverflow: true,
        // stripe: true,
        height: 420,
        align: "left",
        highlightHoverRow: true,
        // treeConfig: { children: "children", expandAll: true },

      },
    };
  },
  components: {
    SearchQuery,
    TitleTag,
  },
  mounted() { },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },

    search() {
      this.checkedList = [];
      this.tableData = [];
      this.res = [];
      const obj = this.$refs.search.getSearchInfo();
      this.$refs.search.searchShow = false;
      if (this.checked) {
        obj.currentPage = 0;
      }
      this.loading = true;
      axios
        .post("/ppm/projectStatus/searchProjectRecordAndExportTemp", obj)
        .then((res) => {
          console.log(res);
          // this.getTable(res);
          this.res = res.data.object.result.rows;
          const arr = res.data.object.result;
          this.columnList = arr.columnInfo.names.map((i, e) => ({ title: i, field: 'a' + e, minWidth: "140", sortable: true }));
          this.getTable(res.data.object.result.rows);
        });
    },
    getTable(data) {
      console.log(data, !data);
      if (!data) {
        this.tableToolbar.buttons[0].name = this.$t("message.title.totalResults") + 0 + this.$t("message.title.resultsNums")
      } else {
        let tempData = data.map(i => i.cells);
        this.tableData = tempData.map(i => {
          let n = {}
          this.columnList.map((j, e) => {
            let val = i[e]?.val ?? '';
            if (i[e]?.date) {
              val = val.split('T')[0];
            }
            Object.assign(n, { [j.field]: val })
          })
          return n
        });

        this.totalRols = data.length;
        this.tableToolbar.buttons[0].name = this.$t("message.title.totalResults") + this.totalRols + this.$t("message.title.resultsNums")
      }
      this.loading = false;
    },

    getSelectEvent() {
      let data = this.$refs.xTable.getCheckboxRecords();
      console.log(data);
      data = data.map(i => {
        let arr = Object.values(i)
        arr.pop()
        return arr;
      })
      this.exportBOM(data);

    },
    // checkRow(row,checked){
    //   this.$refs.xTable.toggleCheckboxRow(row);
    //   if (checked) {
    //     this.checkedList.splice(this.checkedList.indexOf(row.objId),1)
    //   } else {
    //     this.checkedList.push(row.objId)
    //   }
    // },
    // checkAllRows(checked){
    //   this.$refs.xTable.toggleAllCheckboxRow()
    //   let arr = [... new Set(this.res.map(i => i.objId))];
    //   this.checkedList = checked ? [] : arr;
    // },
    // getColumns(){
    //   axios.get("/pmdm/import/getTemplateTitle").then(res =>{
    //     console.log(res);
    //     // let columnList = [];
    //     this.columnList = res.data.object.map((i, e) => ({ title: i, field:'a'+ (e+1) ,minWidth:"140"}));
    //     this.columnList[2].treeNode = true;
    //     console.log(this.columnList);
    //   })
    // },

    exportBOM(arr) {
      NProgress.start();
      // 对数据预处理
      let title = this.columnList.map(i => i.title);
      let data = [];
      arr.map(i => data.push(Object.values(i)));
      data.unshift(title);
      console.log(data);

      // 转换数据
      let book = XLSX.utils.book_new();
      let sheet = XLSX.utils.json_to_sheet(data, { skipHeader: true });
      XLSX.utils.book_append_sheet(book, sheet);
      let wbout = XLSX.write(book, {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
      });
      let blob = new Blob([this.toBuffer(wbout)], {
        type: "application/octet-stream",
      });
      // 保存导出
      FileSaver.saveAs(blob, "项目计划备注模板" + this.formatDate(new Date()) + '.xlsx');
      NProgress.done();
    },


    formatDate(date) {
      var date = new Date(date);
      var YY = date.getFullYear();
      var MM =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1);
      var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hh =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours());
      var mm =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes());
      var ss =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return YY + MM + DD + hh + mm + ss;
    },

  },
  created() {
    // this.getColumns();
  }
};
</script>


<style scoped>
.custom-checkbox {
  font-size: 18px;
}

.pagination {
  margin-top: 15px;
  text-align: left;
}

.search-condition {
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
  margin-left: 10px;
}

.search-title {
  /* width: 120px; */
  padding-right: 120px;
  margin-left: 15px;
}

.search-content {
  margin: 10px 10px;
}

.btn {
  display: inline-block;
  padding: 3px;
  padding-right: 10px;
  border: 1px solid #000;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 8px;
  font-size: 14px;
}

.btn i {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  top: 3px;
  font-size: 14px;
}

.btn img {
  height: 100%;
  width: 100%;
}

.btn6 {
  height: 32px;
  /* line-height: 32px; */
  color: #f5a521;
  border-color: rgba(245, 165, 33, 0.5);
  background: rgba(245, 165, 33, 0.2);
  margin: 0;
  position: relative;
  /* top: 2px; */
}

.btn6:hover {
  color: #fff;
  background: rgba(245, 165, 33, 0.4);
}

.el-selector-search {
  width: 18px;
}

.mytable-scrollbar ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/*滚动条的轨道*/
.mytable-scrollbar ::-webkit-scrollbar-track {
  background-color: #FFFFFF;
}

/*滚动条里面的小方块，能向上向下移动*/
.mytable-scrollbar ::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 5px;
  border: 1px solid #F1F1F1;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:hover {
  background-color: #A8A8A8;
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:active {
  background-color: #787878;
}

/*边角，即两个滚动条的交汇处*/
.mytable-scrollbar ::-webkit-scrollbar-corner {
  background-color: #FFFFFF;
}
</style>